import { connect } from 'react-redux';
import NewsCategory from '../../api/newsCategoryEntity';
import { IState } from '../../reducers';
import  { fetchTopicItemsAction, fetchTopicItemsByCategoryAction, fetchTopicItemsCategoriesAction }  from './actions/fetchNewsAndEventsItems';

import {TopicItemsListPage} from './newsListPage';

const mapStateToProps = (state: IState, ownProps: any) => ({
  categoriesFilter: ownProps.params.categories,
  newsEventCategories: getUniqueCategories(state.eventsAndNewsItems.newsCategories, state.eventsAndNewsItems.eventCategories),
  topicListItemsDto: state.eventsAndNewsItems.topicListItemsDto
});

function getUniqueCategories(newsCategories: NewsCategory[], eventCategories: NewsCategory[]) : NewsCategory[] {

  if (newsCategories.length === 0 && eventCategories.length === 0) {
    return [];
  }

  const categories = Array<NewsCategory>();
  
  newsCategories.forEach(item => {
    const categoty = new NewsCategory;
    categoty.contentTypeId = item.contentTypeId;
    categoty.friendlyUrl = item.friendlyUrl;
    categoty.id = item.id;
    categoty.title = item.title;

    categories.push(categoty);
  });
  eventCategories.forEach(item => {
    const categoty = new NewsCategory;
    categoty.contentTypeId = item.contentTypeId;
    categoty.friendlyUrl = item.friendlyUrl;
    categoty.id = item.id;
    categoty.title = item.title;

    if (!categories.some(e => e.friendlyUrl === categoty.friendlyUrl)) {
      categories.push(categoty);
    } else {
      const cat = categories.find(e => e.friendlyUrl === categoty.friendlyUrl);
      cat!.id = cat!.id + "," + categoty.id;
    }
  });

  return categories;
}

const mapDispatchToProps = (dispatch: any) => ({
  fetchTopicItems: (query?: object) => dispatch(fetchTopicItemsAction(query)),
  fetchTopicItemsByCategory: (categories: string, query?: object) => dispatch(fetchTopicItemsByCategoryAction(categories, query)),
  fetchTopicItemsCategories: () => dispatch(fetchTopicItemsCategoriesAction())
});

export const NewsListPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TopicItemsListPage);



// WEBPACK FOOTER //
// ./src/components/newsListPage/newsListPageContainer.tsx